import React from 'react';
import { string, shape, bool, func } from 'prop-types';
import { TableCell, Tooltip, TableSortLabel } from '@mui/material';
import { I18n } from 'utils/i18n';

const Cell = ({ order, label, name, sortable, onSort }) => {
  const sortBy = () => onSort(name);

  return (
    <TableCell sx={{ pt: 0, pb: 0, fontSize: '13px' }}>
      {sortable ? (
        <Tooltip title={I18n.t('Sort')} enterDelay={300}>
          <TableSortLabel
            hideSortIcon={!sortable}
            active={order.by === name}
            onClick={sortBy}
            direction={order.isReverse ? 'desc' : 'asc'}
          >
            {label}
          </TableSortLabel>
        </Tooltip>
      ) : (
        label
      )}
    </TableCell>
  );
};

Cell.propTypes = {
  sortable: bool.isRequired,
  label: string.isRequired,
  name: string.isRequired,
  onSort: func.isRequired,
  order: shape({
    by: string.isRequired,
    isReverse: bool.isRequired,
  }).isRequired,
};

export default Cell;
